export default {"src":"/_next/static/media/be_in_crypto.af99e644.svg","height":21,"width":135,"blurWidth":0,"blurHeight":0};